import { render, staticRenderFns } from "./nao-pagos.vue?vue&type=template&id=24f10d5b&scoped=true&"
import script from "./nao-pagos.vue?vue&type=script&lang=js&"
export * from "./nao-pagos.vue?vue&type=script&lang=js&"
import style0 from "./nao-pagos.vue?vue&type=style&index=0&id=24f10d5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f10d5b",
  null
  
)

export default component.exports